var _path, _circle, _circle2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenefit2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.575 29c0 14.125-11.45 25.575-25.575 25.575S2.425 43.125 2.425 29 13.875 3.425 28 3.425 53.575 14.875 53.575 29z",
    stroke: "#D8B4FE",
    strokeWidth: 2.85
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 47,
    r: 5,
    fill: "#9333EA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 12,
    r: 5,
    fill: "#9333EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.134 72V29.913c0-1.057.857-1.913 1.913-1.913h9.584c.592 0 1.15.274 1.512.741l3.28 4.233h29.624c1.056 0 1.913.856 1.913 1.913v35.2A1.913 1.913 0 0171.047 72H25.134z",
    fill: "#581C87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.013 34.726a1.913 1.913 0 011.9-2.134h9.348c.592 0 1.15.274 1.513.741l3.279 4.233h29.863c.958 0 1.77.71 1.896 1.66L68.96 70.34c.127.95.938 1.66 1.897 1.66H23.058c-.971 0-1.788-.727-1.9-1.691l-4.146-35.583z",
    fill: "#C084FC"
  })));
}
export default SvgBenefit2;